// extracted by mini-css-extract-plugin
export default {"m":"Breadcrumb_m__rCcFh","m_laster":"Breadcrumb_m_laster__WjxDI","mLaster":"Breadcrumb_m_laster__WjxDI"};